import {
  Box,
  Paper,
  Stack,
  Typography,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
  FormControl,
  InputLabel,
} from "@mui/material";
import React, { useMemo } from "react";
import NavTabs from "../../../../../components/Tabs/NavTabs";
import {
  fullPageBoxStyle,
  verticalTabStyle,
} from "../../../../../styles/muiProps";
import AutodeskViewerTab from "./AutodeskViewerTab";
import Project4d from "./4d/Project4d";
import Project5d from "./5d/Cost";
import FabHours from "./FAbHours";
import Scurve from "./SCurve";
import FilterListIcon from "@mui/icons-material/FilterList";
import { PMSProvider, usePMS } from "./PMSContext";
// import TimelineComponent from './4d/TimelineComponent'

const PMSTab2Inner = ({ plant = false }) => {
  const { plantProjects, selectedProjectIndices, setSelectedProjectIndices } =
    usePMS();
  const assembly = selectedProjectIndices;

  const tabs = [
    // {
    //     label: "2D-3D",
    //     panelProps: { backgroundColor: "transparent", padding: 1 },
    //     panel: (
    //         <AutodeskViewerTab />
    //     )
    // },
    {
      label: "4D (Schedule)",
      // panelProps: { backgroundColor: "transparent", padding: 1 },
      panel: (
        // <TimelineTab equipId={equipId} />
        <Project4d plant={plant} projectFilter={assembly} />
      ),
    },
    {
      label: "5D (Material Cost)",
      // panelProps: { backgroundColor: "transparent", padding: 1 },
      panel: <Project5d plant={plant} projectFilter={assembly} />,
    },
    {
      label: "5D (FAbrication Hours)",
      // panelProps: { backgroundColor: "transparent", padding: 1 },
      panel: <FabHours plant={plant} projectFilter={assembly} />,
    },
    {
      label: "5D (Sub Contractor Cost)",
      // panelProps: { backgroundColor: "transparent", padding: 1 },
      panel: <></>,
    },

    // {
    //   label: "S-Curve",
    //   // panelProps: { backgroundColor: "transparent", padding: 3 },
    //   panel: <Scurve />,
    // },
    // {
    //   label: "Change Order",
    //   // panelProps: { backgroundColor: "transparent", padding: 3 },
    //   panel: <></>,
    // },
  ];

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {plant && (
        <Stack
          direction={"row"}
          padding={2}
          spacing={2}
          sx={{ alignItems: "center", flexWrap: "wrap" }}
        >
          <FilterListIcon color="secondary" />
          <Typography variant="h6" color="darkBlue">
            Sub Projects:
          </Typography>
          <FormControl sx={{ minWidth: 320 }}>
            <InputLabel id="project-select-label">Sub Projects</InputLabel>
            <Select
              multiple
              labelId="project-select-label"
              id="project-select"
              value={assembly}
              label="Sub Projects"
              onChange={(e) => {
                let selectedIndices =
                  typeof e.target.value === "string"
                    ? e.target.value.split(",").map(Number)
                    : e.target.value;

                // If "All Projects" option is chosen, normalize to "no specific project"
                if (
                  Array.isArray(selectedIndices) &&
                  selectedIndices.includes(-1)
                ) {
                  selectedIndices = [];
                }

                setSelectedProjectIndices(selectedIndices);
              }}
              input={<OutlinedInput label="Sub Projects" />}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return <em>All Projects</em>;
                }
                return (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((idx) => {
                      const proj = plantProjects?.[idx];
                      return (
                        <Chip
                          key={idx}
                          label={
                            proj?.name || proj?.title || `Project ${idx + 1}`
                          }
                          size="small"
                        />
                      );
                    })}
                  </Box>
                );
              }}
            >
              {/* Explicit "All Projects" option */}
              <MenuItem value={-1} key="all-projects">
                <em>All Projects</em>
              </MenuItem>

              {(plantProjects || []).map((p, i) => (
                <MenuItem value={i} key={i}>
                  {p.name || p.title || `Project ${i + 1}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {assembly.length > 0 && (
            <Typography variant="body2" color="text.secondary">
              {assembly.length} project{assembly.length !== 1 ? "s" : ""}{" "}
              selected
            </Typography>
          )}
        </Stack>
      )}

      <Paper sx={{ width: "100%", display: "flex", flex: 1 }}>
        <NavTabs
          tabs={tabs}
          // tabProps={verticalTabStyle}
          navLabel="pms-tab"
          // vertical={true}
        />
      </Paper>
    </Box>
  );
};

const PMSTab2 = ({ plant = false }) => {
  // Always wrap in provider; it no-ops when plant is false
  return (
    <PMSProvider plant={plant}>
      <PMSTab2Inner plant={plant} />
    </PMSProvider>
  );
};

export default PMSTab2;
